import React from "react";
import { PaymentsRoutesResponse } from "src/api";
import AlfredWithdrawalForm from "./AlfredWithdrawalForm";
import "./withdrawal-form.scss";

/**
 * Withdrawal entry point. The widget is bound to a single payment
 * route per session, and Alfred is the only PSP we currently render
 * here, so this component just delegates to the Alfred form. The
 * route's `verification_type` lets the form open the matching
 * second-factor input up front.
 */
const WithdrawalForm: React.FC<{
  paymentsRoutes: PaymentsRoutesResponse;
}> = ({ paymentsRoutes }): JSX.Element => {
  return <AlfredWithdrawalForm verificationType={paymentsRoutes.verification_type} />;
};

export default WithdrawalForm;
